import { Plugin } from '@nuxt/types';
import {
  browserProfilingIntegration,
  browserTracingIntegration,
  init,
  replayIntegration,
} from '@sentry/vue';
import Vue from 'vue';

const sentryPlugin: Plugin = ({ app }) => {
  const { router, context } = app;

  const {
    dsn,
    environment,
    traces_sample_rate: tracesSampleRate,
    profiles_sample_rate: profilesSampleRate,
    replays_session_sample_rate: replaysSessionSampleRate,
    replays_on_error_sample_rate: replaysOnErrorSampleRate,
  } = context.$config.sentry;

  init({
    Vue,

    dsn,
    environment,
    release: process.env.SENTRY_RELEASE,

    integrations: [
      browserTracingIntegration({ router, routeLabel: 'path' }),
      browserProfilingIntegration(),
      replayIntegration(),
    ],

    trackComponents: true,

    tracesSampleRate,
    profilesSampleRate,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
  });
};

export default sentryPlugin;
